<section style="text-align: center;" *ngIf="tableDataSource.data.length == 0">
    <h3>{{ noContentMessage }}</h3>
</section>

<section *ngIf="tableDataSource.data.length > 0">
    <div class="overflow-table">
        <table mat-table matSort [dataSource]="tableDataSource">
            <ng-container *ngFor="let column of columnsConfiguration"
                [matColumnDef]="column.columnId">
                <th class="th-header" mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!column.isSortable">
                    {{ column.headerText }}
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container>
                        <h6 [ngSwitch]="column.type">
                            <span *ngSwitchCase="'number'">{{ element[column.columnId] | number }}</span>
                            <span *ngSwitchCase="'date'">{{ (element[column.columnId] | date : 'dd-MM-yyyy') || column.defaultIfEmpty }}</span>
                            <span *ngSwitchCase="'currency'">{{ (element[column.columnId] | currency : 'CLP') || column.defaultIfEmpty }}</span>
                            <span *ngSwitchCase="'percentage'">{{ (element[column.columnId] | number: '1.2-2') +'%' || column.defaultIfEmpty }}</span>
                            <span *ngSwitchCase="'decimal'">{{ (element[column.columnId] | number: '1.2-2') || column.defaultIfEmpty }}</span>
                            <a class="anchor" *ngSwitchCase="'anchor'" target="_blank" [href]="generateUrl(column.anchorUrlTemplate, column.urlParams, element)">
                                {{ (element[column.columnId] ) || column.defaultIfEmpty }}
                            </a>
                            <span *ngSwitchDefault>{{ (element[column.columnId] ) || column.defaultIfEmpty }}</span>
                        </h6>
                    </ng-container>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="getColumns()"></tr>
            <tr mat-row *matRowDef="let row; columns: getColumns()"
                [ngStyle]="{'cursor': rowEvents ? 'pointer' : '' }"
                [cdkContextMenuTriggerFor]="contextmenu">
                <ng-template #contextmenu>
                    <div cdkMenu class="context_menu mat-elevation-z0">
                        <ul>
                            <li *ngFor="let rowEvent of rowEvents">
                                <button mat-raised-button
                                    (click)="rowEvent.eventHandler(row)"
                                    cdkMenuItem>
                                    {{rowEvent.title}}
                                </button>
                            </li>
                            <li *ngFor="let rowEvent of rowEvents">
                                <button mat-raised-button
                                style="background-color: green; color: white;"
                                    (click)="abrirEvento(row.warrantyId)"
                                    cdkMenuItem>
                                   Ver Eventos
                                </button>
                            </li>
                        </ul>
                    </div>                    
                </ng-template>
            </tr>
        </table>
    </div>
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
</section>